module.exports = __webpack_public_path__ + "img/step_three.26cfc05f.jpg";